import React from 'react'

function CustomerAccountItemHeaderStyle() {
  return (
    <React.Fragment>
      <style jsx='true'>
      {`
        .content-header-content { display: flex; }
        .content-header-content .caption { flex: 1; }
      `}
      </style>
    </React.Fragment>
  )
}

export default React.memo(CustomerAccountItemHeaderStyle)
